import { FC } from 'react'

import useParametrizationConfigPurchase from '@hook/parametrization/use-config-purchase'

import HistoricModal, {
  HISTORIC_COLUMNS
} from '@component/Parameterization/Shared/HistoricModal'

import ParametroCompra from '@service/ParametroCompra'

const ModalHistoricPurchaseCronograma: FC = () => {
  const { companieId, selectedComprador } = useParametrizationConfigPurchase()
  return (
    <HistoricModal
      title="Histórico Cronograma de Compras"
      empresaId={companieId}
      reloadKey={selectedComprador}
      fetcher={async empresaId =>
        (
          await ParametroCompra.getCronogramaComprasHistorico(
            empresaId,
            selectedComprador || undefined
          )
        ).data?.data ?? []
      }
      columns={[
        HISTORIC_COLUMNS.data,
        HISTORIC_COLUMNS.usuario,
        HISTORIC_COLUMNS.empresa,
        HISTORIC_COLUMNS.acao
      ]}
      emptyMessage="Nenhum histórico de cronograma encontrado."
    />
  )
}

export default ModalHistoricPurchaseCronograma
